import { createStore } from 'vuex'

import events from './events'
import user from './user'
import shared from './shared'

export const store = createStore({
  modules: {
    events: events,
    user: user,
    shared: shared
  }
})
